module.exports = __webpack_public_path__ + "assets/img/image3.3f4217d8.png";